import { useLogoutFunction } from '@propelauth/react';

import { useGlobalStore } from '../../../stores/useGlobalStore';

const useLogout = () => {
  const logoutFunction = useLogoutFunction();
  const setUserInfo = useGlobalStore((s) => s.setUser);
  const onLogout = async () => {
    await logoutFunction(false);
    setUserInfo(null);
  };
  return onLogout;
};

export { useLogout };
